<template>
  <div class="tourHotelPlaceModal_search">
    <slot name="beforeInput">
      <label class="tourHotelPlaceModal_searchLabel">
        <span>{{ label }}</span>
      </label>
      <tk-icon v-if="icon" :name="icon" :alt="label" />
    </slot>
    <input v-model.trim="query" type="search" :placeholder="placeholder" />
    <div
      v-show="!!query.length"
      class="alternative-pc-list-box display-n"
      style="display: block;"
    >
      <div v-if="!!items.length">
        <tk-link
          v-for="(item, index) in items"
          :key="index"
          @click="onSelected(item)"
        >
          <slot :item="item">
            <span>{{ item.label }}</span>
          </slot>
        </tk-link>
      </div>
      <div v-else>
        <div
          style="font-weight: bold; color: rgb(154, 154, 154); padding: 10px;"
        >
          {{ notFoundMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import TkIcon from '../../atoms/TkIcon/TkIcon'
import TkLink from '../../atoms/TkLink/TkLink'

export default {
  name: 'TkAutocomplete',
  components: {
    TkIcon,
    TkLink,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    notFoundMessage: {
      type: String,
      default: '',
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    debounceTime: {
      type: [Number, String],
      default: 0,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      query: '',
      items: [],
    }
  },
  watch: {
    query(query) {
      if (!query || !query.length) {
        this.items = []
        return
      }

      this.triggerInputChange()
    },
    suggestions() {
      this.items = this.suggestions
    },
  },
  created() {
    const debounceTime = parseInt(this.debounceTime, 10) || 0
    this.triggerInputChange = debounce(function () {
      this.$emit('input', this.query)
    }, debounceTime)
  },
  methods: {
    onSelected(item) {
      this.query = ''
      this.$emit('selected', item)
    },
  },
}
</script>
